import React, {useState} from 'react'
import Button from '../Button'
import { setUsername, handleSubmitLogin } from '../../Actions/BackofficeLogin.action'
import Input from '../Inputs/Input'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from '../../Hooks/useTypedSelector'

const BackofficeLoginForm = () => {
    const dispatch = useDispatch();
    const { username, error, isLoading } = useTypedSelector((state) => state.backofficeLogin);

    const [password, setPassword] = useState<string>();
    
    const submitLogin = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        dispatch(handleSubmitLogin(username, password));
    }

    return (
        <form id="backoffice-login-form" className="flex flex-col gap-4 w-full px-13" onSubmit={submitLogin} method='post'>
            <Input
                label="Username"
                inputSize="large"
                wrapperClassName="input__wrapper"
                placeholder="Username"
                onChange={(e) => (dispatch(setUsername(e.target.value)))}
                disabled={isLoading}
                autoComplete="username"
            />
            <Input
                label="Password"
                inputSize="large"
                wrapperClassName="input__wrapper"
                placeholder="Password"
                onChange={(e) => (setPassword(e.target.value))}
                disabled={isLoading}
                type="password"
                id="password"
                autoComplete="current-password"
            />
            <div className="text-md text-[#EF4444] min-h-[16px]">
                {error?.Login && <span>{error.Login}</span>}
                {error?.Unauthorized && <span>{error.Unauthorized}</span>}
                {error?.General && <span>{error.General}</span>}
            </div>
            <Button
                btnSize="large"
                btnType="primary"
                fullwidth={true}
                type="submit"
                className="submit"
                disabled={username === '' || password === '' || isLoading}
            >Submit</Button>
        </form>
    )
}

export default BackofficeLoginForm
